import {
  generateDesktopSourcesForPicture,
  generateMobileSourcesForPicture,
} from '@farmersdog/corgi-x';
import BowlPackMobilePng from './bowl-pack-mobile.png';
import BowlPackMobileWebp from './bowl-pack-mobile.webp';
import BowlDesktopPng from './bowl-desktop.png';
import BowlDesktopWebp from './bowl-desktop.webp';
import PackDesktopPng from './pack-desktop.png';
import PackDesktopWebp from './pack-desktop.webp';
import RedX from './red-x.svg';

export const bowlPackMobileSources = generateMobileSourcesForPicture({
  png: BowlPackMobilePng,
  webP: BowlPackMobileWebp,
});

export const bowlDesktopSources = generateDesktopSourcesForPicture({
  png: BowlDesktopPng,
  webP: BowlDesktopWebp,
});

export const packDesktopSources = generateDesktopSourcesForPicture({
  png: PackDesktopPng,
  webP: PackDesktopWebp,
});

export { RedX };
